/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {UserPermissionTypes} from '../../../../app/common/constants/userPermissionTypes'
import {Features} from '../../../../app/common/constants/features'

export function AsideMenuMain() {
  const intl = useIntl()
  const dispatch = useDispatch()

  const permissions: any = useSelector<RootState>(
    ({auth}) => auth.userPermission,
    shallowEqual
  ) as any

  const features: any = useSelector<RootState>(({auth}) => auth.tenantFeatures, shallowEqual) as any

  const localization: any = useSelector<RootState>(
    ({accountSetting}) => accountSetting.localization,
    shallowEqual
  ) as any
  const connectLabel = localization?.ConnectLabel ?? 'Connect Day'

  const loc = window.location.href

  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any

  return (
    <>
      {permissions?.includes('dashboard.menu') && (
        <AsideMenuItem
          to='/site-overview'
          title='Site Dashboard'
          icon='/media/icons/duotune/maps/map002.svg'
          fontIcon='bi-building'
        ></AsideMenuItem>
      )}
      {/* {permissions?.includes('dashboard.menu') && (
        <AsideMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/general/gen001.svg'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
        />
      )} */}
      {permissions?.includes('bookings.menu') && (
        <AsideMenuItemWithSub
          to='/bookings'
          title='Bookings'
          icon='/media/icons/duotune/files/fil002.svg'
          fontIcon='bi-person'
          children={
            <>
              <AsideMenuItem
                to='/bookings/list'
                title='List View'
                hasBullet
                fontIcon='bi-person'
              ></AsideMenuItem>
              <AsideMenuItem
                to='/bookings/planner'
                title='Planner View'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem>
              <AsideMenuItem
                to='/bookings/release-report'
                title='Release Report'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem>
            </>
          }
        />
      )}
      {permissions?.includes('myDays.menu') && (
        <AsideMenuItem
          to='/day-plans'
          title='Day Plan'
          icon='/media/icons/duotune/general/gen013.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('events.menu') && (
        <AsideMenuItem
          to='/events/list'
          title='Events'
          icon='/media/icons/duotune/files/fil002.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('activityFeed.menu') && (
        <AsideMenuItem
          to='/activity-feeds'
          title='Activity Feeds'
          icon='/media/icons/duotune/communication/com004.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('reports.menu') && (
        <AsideMenuItemWithSub
          to='/reports'
          title='Reports'
          icon='/media/icons/duotune/general/gen005.svg'
          fontIcon='bi-person'
          children={
            <>
              {/* <AsideMenuItem
                to='/reports/activity'
                title='Activity'
                hasBullet
                fontIcon='bi-person'
              ></AsideMenuItem> */}
              <AsideMenuItem
                to='/reports/occupancy'
                title='Occupancy'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem>
              {/* <AsideMenuItem
                to='/reports/occupancy-v2'
                title='Occupancy V2'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem> */}
              <AsideMenuItem
                to='/reports/asset-usage'
                title='Asset Usage'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem>
              {/* <AsideMenuItem
                to='/reports/assets-roll-up'
                title='Asset Roll Up'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem> */}
            </>
          }
        />
      )}
      {permissions?.includes('users.menu') && (
        <AsideMenuItem
          to='/users'
          title='Users'
          icon='/media/icons/duotune/communication/com006.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('teams.menu') && (
        <AsideMenuItem
          to='/teams'
          title='Teams'
          icon='/media/icons/duotune/communication/com005.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('sites.menu') && (
        <AsideMenuItem
          to='/sites'
          title='Sites'
          icon='/media/icons/duotune/maps/map002.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('notices.menu') && (
        <AsideMenuItem
          to='/notices'
          title='Notices'
          icon='/media/icons/duotune/abstract/abs039.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {/* {features?.includes('lockers') && permissions?.includes('lockers.menu') && (
        <AsideMenuItem
          to='/locker-locations'
          title='Lockers'
          icon='/media/icons/duotune/communication/com010.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )} */}
      {permissions?.includes('messages.menu') && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
              Notification center
            </span>
          </div>
        </div>
      )}
      {permissions?.includes('messages.menu') && (
        <AsideMenuItem
          to='/messages'
          title='Messages'
          icon='/media/icons/duotune/communication/com002.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('messages.menu') && (
        <AsideMenuItem
          to='/daysie-notifications'
          title='Notifications'
          icon='/media/icons/duotune/communication/com002.svg'
          fontIcon='bi-envelope'
        ></AsideMenuItem>
      )}
      {(permissions?.includes('assets.menu') ||
        permissions?.includes('assetTypes.menu') ||
        permissions?.includes('attributes.menu') ||
        permissions?.includes('allocations.menu') ||
        permissions?.includes('checkInStrategies.menu') ||
        permissions?.includes('neighborhoods.menu')) && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Assets</span>
          </div>
        </div>
      )}
      {permissions?.includes('assets.menu') && (
        <AsideMenuItem
          to='/assets/list'
          title='Assets'
          icon='/media/icons/duotune/abstract/abs027.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('assetTypes.menu') && (
        <AsideMenuItem
          to='/asset-types'
          title='Asset Types'
          icon='/media/icons/duotune/art/art002.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('attributes.menu') && (
        <AsideMenuItem
          to='/attributes'
          title='Attributes'
          icon='/media/icons/duotune/abstract/abs020.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('allocations.menu') && (
        <AsideMenuItem
          to='/allocations'
          title='Allocations'
          icon='/media/icons/duotune/abstract/abs026.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('checkInStrategies.menu') && (
        <AsideMenuItem
          to='/checkin-strategies'
          title='Checkin Strategies'
          icon='/media/icons/duotune/arrows/arr035.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('neighborhoods.menu') && (
        <AsideMenuItem
          to='/zones'
          title='Zones'
          icon='/media/icons/duotune/maps/map006.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {(permissions?.includes('publicHoliday.menu') ||
        permissions?.includes('userTypes.menu') ||
        permissions?.includes('userSkills.menu') ||
        permissions?.includes('siteTypes.menu') ||
        permissions?.includes('noticeTypes.menu') ||
        permissions?.includes('notWorkingReasons.menu') ||
        permissions?.includes(UserPermissionTypes.MENU_RELEASE_REASONS) ||
        permissions?.includes('roles.menu') ||
        permissions?.includes('account.menu') ||
        permissions?.includes('accountThemes.menu')) && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Administration</span>
          </div>
        </div>
      )}

      {features?.includes('guest-users') && permissions?.includes('invitations.menu') && (
        <AsideMenuItem
          to='/invites'
          title='Invites'
          icon='/media/icons/duotune/communication/com010.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {features?.includes(Features.PARCELS) &&
        (permissions?.includes('parcels.menu') ||
          permissions?.includes('parcel-locations.menu') ||
          permissions?.includes('parcel-types.menu') ||
          permissions?.includes('couriers.menu')) && (
          <AsideMenuItemWithSub
            to='/parcels'
            title='Parcels'
            icon='/media/icons/duotune/general/gen017.svg'
            fontIcon='bi-box'
            activePaths={['/parcels', '/parcel-types', '/parcel-locations', '/couriers']}
            children={
              <>
                {permissions?.includes('parcels.menu') && (
                  <AsideMenuItem to='/parcels/list' title='Parcels' hasBullet fontIcon='bi-box' />
                )}
                {permissions?.includes('parcel-types.menu') && (
                  <AsideMenuItem
                    to='/parcel-types/list'
                    title='Parcel Types'
                    hasBullet
                    fontIcon='bi-box-seam'
                  />
                )}

                {permissions?.includes('parcel-locations.menu') && (
                  <AsideMenuItem
                    to='/parcel-locations/list'
                    title='Parcel Locations '
                    hasBullet
                    fontIcon='bi-box-seam'
                  />
                )}

                {permissions?.includes('couriers.menu') && (
                  <AsideMenuItem
                    to='/couriers/list'
                    title='Couriers'
                    hasBullet
                    fontIcon='bi-box-seam'
                  />
                )}
              </>
            }
          />
        )}

      {features?.includes(Features.DESKWORKS) &&
        (permissions?.includes('deskworks-gateway.menu') ||
          permissions?.includes('deskworks-controllercolors.menu')) && (
          <AsideMenuItemWithSub
            to='/deskworks'
            title='Desk Works'
            icon='/media/icons/duotune/abstract/abs010.svg'
            fontIcon='bi-box'
            children={
              <>
                {permissions?.includes('deskworks-gateway.menu') && (
                  <AsideMenuItem
                    to='/deskworks-gateway/list'
                    title='Gateway'
                    hasBullet
                    fontIcon='bi-box'
                  />
                )}
                {permissions?.includes('deskworks-controllercolors.menu') && (
                  <AsideMenuItem
                    to='/deskworks-controllercolors/list'
                    title='Controller Colors'
                    hasBullet
                    fontIcon='bi-box-seam'
                  />
                )}
              </>
            }
          />
        )}

      {/* Parking Menu */}
      {features?.includes(Features.PARKING) &&
        (permissions?.includes('parking-bookings.menu') ||
          permissions?.includes('vehicles.menu')) && (
          <AsideMenuItemWithSub
            to='/parking'
            title='Parking'
            icon='/media/icons/duotune/maps/map007.svg'
            fontIcon='bi-car-front'
            activePaths={['/parking-bookings', '/car-parks', '/slots', '/vehicles']}
            children={
              <>
                {permissions?.includes('parking-bookings.menu') && (
                  <>
                    <AsideMenuItem
                      to='/parking-bookings/list'
                      title='Bookings'
                      hasBullet
                      fontIcon='bi-calendar-check'
                    />
                    <AsideMenuItem
                      to='/car-parks/list'
                      title='Car Parks'
                      hasBullet
                      fontIcon='bi-building'
                    />

                    <AsideMenuItem
                      to='/slots/list'
                      title='Slots'
                      hasBullet
                      fontIcon='bi-grid-3x3'
                    />
                  </>
                )}

                {permissions?.includes('vehicles.menu') && (
                  <AsideMenuItem
                    to='/vehicles/list'
                    title='Vehicles'
                    hasBullet
                    fontIcon='bi-car-front'
                  />
                )}
              </>
            }
          />
        )}

      {features?.includes(Features.TICKETING) &&
        (permissions?.includes('tickets.menu') || permissions?.includes('ticket-types.menu')) && (
          <AsideMenuItemWithSub
            to='/tickets'
            title='Tickets'
            icon='/media/icons/duotune/files/fil002.svg'
            fontIcon='bi-person'
            activePaths={['/ticket-types', '/ticket-standard-statuses', '/ticket-priorities']}
            children={
              <>
                {permissions?.includes('tickets.menu') && (
                  <AsideMenuItem
                    to='/tickets/list'
                    title='Tickets'
                    hasBullet
                    fontIcon='bi-person'
                  ></AsideMenuItem>
                )}

                <AsideMenuItemWithSub
                  to='/ticket-reports'
                  title='Reports'
                  hasBullet
                  activePaths={['/tickets/dashboard', '/tickets/reports']}
                  children={
                    <>
                      {permissions?.includes('tickets.menu') && (
                        <AsideMenuItem
                          to='/tickets/dashboard'
                          title='SLA Dashboard'
                          hasBullet
                          fontIcon='bi-bar-chart'
                        ></AsideMenuItem>
                      )}

                      {permissions?.includes('tickets.menu') && (
                        <AsideMenuItem
                          to='/tickets/reports'
                          title='Ticket Summary'
                          hasBullet
                          fontIcon='bi-file-earmark-bar-graph'
                        ></AsideMenuItem>
                      )}
                    </>
                  }
                />

                {permissions?.includes('ticket-types.menu') && (
                  <AsideMenuItem
                    to='/ticket-types/list'
                    title='Types & Categories'
                    fontIcon='bi-person'
                    hasBullet
                  ></AsideMenuItem>
                )}

                {permissions?.includes('tickets.menu') && (
                  <AsideMenuItem
                    to='/ticket-standard-statuses/list'
                    title='Statuses'
                    fontIcon='bi-person'
                    hasBullet
                  ></AsideMenuItem>
                )}

                {permissions?.includes('tickets.menu') && (
                  <AsideMenuItem
                    to='/ticket-priorities/list'
                    title='Priorities'
                    fontIcon='bi-person'
                    hasBullet
                  ></AsideMenuItem>
                )}
              </>
            }
          />
        )}
      {features?.includes(Features.HEALTHANDSAFETY) &&
        permissions?.includes('donesafe-forms.menu') && (
          <AsideMenuItem
            to='/health-safety'
            title='Health & Safety'
            icon='/media/icons/duotune/general/gen049.svg'
            fontIcon='bi-shield-check'
          ></AsideMenuItem>
        )}
      {features?.includes(Features.CAFE) && (
        <AsideMenuItemWithSub
          to='/cafe'
          title='Cafe'
          icon='/media/icons/duotune/abstract/abs021.svg'
          fontIcon='bi-cup-hot'
          children={
            <>
              {permissions?.includes('cafe-product-types.menu') && (
                <AsideMenuItem
                  to='/cafe/product-types'
                  title='Product Types'
                  hasBullet
                  fontIcon='bi-collection'
                ></AsideMenuItem>
              )}
              {permissions?.includes('cafe-products.menu') && (
                <AsideMenuItem
                  to='/cafe/products'
                  title='Products'
                  hasBullet
                  fontIcon='bi-person'
                ></AsideMenuItem>
              )}
              {permissions?.includes('cafe-product-options.menu') && (
                <AsideMenuItem
                  to='/cafe/product-options'
                  title='Product Options'
                  hasBullet
                  fontIcon='bi-gear'
                ></AsideMenuItem>
              )}
              {permissions?.includes('cafe-orders.menu') && (
                <AsideMenuItem
                  to='/cafe/orders'
                  title='Orders'
                  hasBullet
                  fontIcon='bi-receipt'
                ></AsideMenuItem>
              )}
              {permissions?.includes('cafe-orders.bump-screen') && (
                // <AsideMenuItem
                //   to='/cafe/bump-screen'
                //   title='Bump Screen'
                //   hasBullet
                //   fontIcon='bi-display'
                // ></AsideMenuItem>
                <div className='menu-item'>
                  <a
                    className='menu-link without-sub'
                    href='/cafe/bump-screen'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <span className='menu-bullet'>
                      <span className='bullet bullet-dot'></span>
                    </span>
                    <span className='menu-title'>Bump Screen</span>
                  </a>
                </div>
              )}
            </>
          }
        />
      )}
      {features?.includes(Features.MANAGED_EVENTS) &&
        permissions?.includes(UserPermissionTypes.MENU_MANAGED_EVENTS) && (
          <AsideMenuItemWithSub
            to='/managed-events'
            title='Managed Events'
            icon='/media/icons/duotune/general/gen025.svg'
            fontIcon='bi-person'
            children={
              <>
                <AsideMenuItem
                  to='/managed-events/list'
                  title='Events'
                  hasBullet
                  fontIcon='bi-person'
                ></AsideMenuItem>
                <AsideMenuItem
                  to='/managed-events/caterings'
                  title='Catering'
                  hasBullet
                  fontIcon='bi-person'
                ></AsideMenuItem>
                <AsideMenuItem
                  to='/managed-events/equipments'
                  title='Equipment'
                  fontIcon='bi-person'
                  hasBullet
                ></AsideMenuItem>
                <AsideMenuItem
                  to='/managed-events/locations'
                  title='Locations'
                  fontIcon='bi-person'
                  hasBullet
                ></AsideMenuItem>
                <AsideMenuItem
                  to='/managed-events/room-setups'
                  title='Room Setups'
                  fontIcon='bi-person'
                  hasBullet
                ></AsideMenuItem>
                <AsideMenuItem
                  to='/managed-events/cost-centers'
                  title='Cost Centers'
                  fontIcon='bi-person'
                  hasBullet
                ></AsideMenuItem>
              </>
            }
          />
        )}
      {permissions?.includes('connect-days.menu') && (
        <AsideMenuItem
          to='/connects'
          title={connectLabel}
          icon='/media/icons/duotune/abstract/abs022.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {(permissions?.includes('projects.menu') || permissions?.includes('projectRoles.menu')) && (
        <AsideMenuItemWithSub
          to='/projects'
          title='Projects'
          icon='/media/icons/duotune/general/gen005.svg'
          fontIcon='bi-person'
          children={
            <>
              {permissions?.includes('projects.menu') && (
                <AsideMenuItem
                  to='/projects'
                  title='Projects'
                  fontIcon='bi-person'
                  hasBullet
                ></AsideMenuItem>
              )}
              {permissions?.includes('projectRoles.menu') && (
                <AsideMenuItem
                  to='/project-roles'
                  title='Project Roles'
                  fontIcon='bi-person'
                  hasBullet
                ></AsideMenuItem>
              )}
            </>
          }
        />
      )}

      {permissions?.includes('publicHoliday.menu') && (
        <AsideMenuItem
          to='/holidays'
          title='Holidays'
          icon='/media/icons/duotune/general/gen014.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('userTypes.menu') && (
        <AsideMenuItem
          to='/user-types'
          title='User Types'
          icon='/media/icons/duotune/general/gen049.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('userSkills.menu') && (
        <AsideMenuItem
          to='/user-skills'
          title='User Skills'
          icon='/media/icons/duotune/general/gen011.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('siteTypes.menu') && (
        <AsideMenuItem
          to='/site-types'
          title='Site Types'
          icon='/media/icons/duotune/communication/com009.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('noticeTypes.menu') && (
        <AsideMenuItem
          to='/notice-types'
          title='Notice Types'
          icon='/media/icons/duotune/abstract/abs043.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('business-unit.menu') && (
        <AsideMenuItem
          to='/business-functions'
          title='Business Functions'
          icon='/media/icons/duotune/ecommerce/ecm009.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('notWorkingReasons.menu') && (
        <AsideMenuItem
          to='/not-working-reasons'
          title='Not Working Reason'
          icon='/media/icons/duotune/medicine/med010.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}

      {permissions?.includes('offSiteReasons.menu') && (
        <AsideMenuItem
          to='/off-site-reasons'
          title='Off-Site Reason'
          icon='/media/icons/duotune/general/gen001.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}

      {permissions?.includes(UserPermissionTypes.MENU_RELEASE_REASONS) && (
        <AsideMenuItem
          to='/release-reasons'
          title='Release Reason'
          icon='/media/icons/duotune/arrows/arr060.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('roles.menu') && (
        <AsideMenuItem
          to='/roles'
          title='Roles'
          icon='/media/icons/duotune/files/fil001.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('account.menu') && (
        <AsideMenuItem
          to='/account'
          title='Account'
          icon='/media/icons/duotune/technology/teh004.svg'
          fontIcon='bi-person'
        ></AsideMenuItem>
      )}
      {permissions?.includes('accountThemes.menu') && (
        <AsideMenuItemWithSub
          to='/themes'
          title='Themes'
          icon='/media/icons/duotune/layouts/lay009.svg'
          fontIcon='bi-person'
          children={
            <>
              <AsideMenuItem
                to='/themes/color/list'
                title='Color'
                hasBullet
                fontIcon='bi-person'
              ></AsideMenuItem>
              <AsideMenuItem
                to='/themes/localization/list'
                title='Localization'
                fontIcon='bi-person'
                hasBullet
              ></AsideMenuItem>
            </>
          }
        />
      )}
    </>
  )
}
